// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"e473128c","695":"6e59e051","875":"b37fad64"}[chunkId] + ".chunk.js";
};